import { render, staticRenderFns } from "./flowrecord.vue?vue&type=template&id=e354a4de"
import script from "./flowrecord.vue?vue&type=script&lang=js"
export * from "./flowrecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports